import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GoPillBadgeComponent } from './go-pill-badge.component';

@NgModule({
  declarations: [GoPillBadgeComponent],
  imports: [CommonModule],
  exports: [GoPillBadgeComponent],
})
export class GoBadgePillModule {}
